// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gj5h","col":"styles_col__30k4z","actions":"styles_actions__2cH54","conflict":"styles_conflict__AzczY"};